"use client";

import React from "react";
import logo from "@/assets/sidebar/help.svg";
import { SectionItem } from "@/components/sidebar/models/section-item";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import SidebarSectionWithItems from "@/components/sidebar/sidebar-components/sidebar-section-with-items";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import SidebarItemProps from "../models/sidebar-item-props";

const HelpSidebarSection = ({ isOpen = true }: SidebarItemProps) => {
  const { showModal } = useGlobalModalContext();
  const showRequestVoiceModal = () => {
    showModal({ type: "request_voice" });
  };

  const { license, isLoading } = useProfileContext();

  const items = [
    {
      title: "FAQ",
      href: "/faq",
    },
    { title: "Contact", href: "/help/contact" },
    {
      title: "Join Discord",
      href: "https://discord.com/invite/Faqt5ZXaXv",
      hrefTarget: "_blank",
    },
    // {
    //   title: "Demo",
    //   href: "/demo",
    // },
    // {
    //   title: "Request Voice",
    //   href: "",
    //   onClick: showRequestVoiceModal,
    // },
    {
      title: "Request Features",
      href: "/requested-features",
    },
  ] as SectionItem[];

  if (license === "Trial" && !isLoading) {
    items.push({
      title: "Get Free Access",
      href: "/get-free-access",
    });
  }
  return (
    <SidebarSectionWithItems
      image={logo}
      title="Help"
      items={items}
      isOpen={isOpen}
    />
  );
};

export default HelpSidebarSection;
